import { EmptyState, useMediaQuery } from "@helmr/ui";
import { useParams } from "react-router-dom";
import { NoAccess } from "../../app/NoAccess";
import { areaAllows } from "../../app/nav";
import { PHONE_QUERY } from "../../app/mobile/query";
import { InboxList } from "./InboxList";
import { Thread } from "./Thread";
import { useInboxAccess } from "./hooks";
import { inbox as t } from "./strings";
import s from "./inbox.module.css";

/**
 * One model on both widths. A phone shows the list, and a thread slides over it; from 768px the list (360px) and the
 * open thread sit side by side inside the sidebar shell.
 */
export function InboxPage() {
  const { id } = useParams();
  const phone = useMediaQuery(PHONE_QUERY);
  const { ctx } = useInboxAccess();
  if (ctx.status !== "loading" && !areaAllows("inbox", ctx.has)) return <NoAccess />;
  if (phone) {
    return (
      <>
        <InboxList phone activeId={id} />
        {id ? <Thread key={id} id={id} phone /> : null}
      </>
    );
  }
  return (
    <div className={s.panes}>
      <InboxList phone={false} activeId={id} />
      <section className={s.pane} aria-label="Conversation">
        {id ? <Thread key={id} id={id} phone={false} /> : <EmptyState icon="chat" title={t.thread.select} description={t.thread.selectBody} />}
      </section>
    </div>
  );
}
